import { render, staticRenderFns } from "./Grenstall.vue?vue&type=template&id=4c97615e&scoped=true"
import script from "./Grenstall.vue?vue&type=script&lang=js"
export * from "./Grenstall.vue?vue&type=script&lang=js"
import style0 from "./Grenstall.vue?vue&type=style&index=0&id=4c97615e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c97615e",
  null
  
)

export default component.exports